import React, { useState, useEffect, useContext, useMemo } from "react";
import Slideshow from "./Slideshow";
import ContinueWatch from "./ContinueWatch";
import { Contextone } from "./Context";
import Moviecard from "./Moviecard";
import { ShimmerThumbnail } from "react-shimmer-effects"; // Assuming correct import for Shimmer components
import { fetchBanner, fetchSectionList } from "./Api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const News = () => {
  const [sectionlist, setSectionlist] = useState([]);
  const [continueList, setContinueList] = useState([]);
  const [banner, setBanner] = useState([]);
  const [bannerData, setBannerData] = useState('');
  const [languageId, setLanguageId] = useState(0);
  const [loading, setLoading] = useState(false); // Combined loading state

  const countercontext = useContext(Contextone);
  const isurl = countercontext.isDomain;
  const apiUrl = `https://${isurl}`;
  const cache = useMemo(() => ({}), []);

  useEffect(() => {
    let type_idd = 5;
    let isHome = 2;
    setLoading(true);
    
    const cacheKey = `${type_idd}-${isHome}-${languageId}`;
    if (cache[cacheKey]) {
      const { bannerData, sectionData } = cache[cacheKey];
      setBanner(bannerData.result);
      setSectionlist(sectionData.result);
      setContinueList(sectionData.continue_watching);
      setLoading(false);
    } else {
      fetchData(type_idd, isHome, languageId, cacheKey);
    }
  }, []);

  const fetchData = async (type_id, is_home, lang, cacheKey) => {
    try {
      const bannerData = await fetchBanner(apiUrl,type_id, is_home, lang);
      const sectionData = await fetchSectionList(apiUrl,type_id, is_home, lang);
      cache[cacheKey] = { bannerData, sectionData }; // Cache the data
      setBanner(bannerData.result);
      setSectionlist(sectionData.result);
      setContinueList(sectionData.continue_watching);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (banner && banner.length > 0) {
      setBannerData(banner[0].id);
    } else {
      setBannerData(null); 
    }
  }, [banner]);

  return (
    <>
      <div>
        {loading ? (
          <div style={{ marginTop: "60px", width: "100vw", minWidth: "100vw" }}>
            <div className="shimmer-container">
              <ShimmerThumbnail className="shimmer-thumbnail" />
            </div>
            <Moviecard loading={true} />
          </div>
        ) : (
          <div className="home-body">
            {bannerData ? (
              <>
                <Slideshow data={banner} bannervisible={true} />
                <Moviecard data={sectionlist} bannervisible={true} loading={false} />
              </>
            ) : (
              <>
                <Moviecard data={sectionlist} bannervisible={false} loading={false} />
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default News;
